/**
 * Issue #228 — 完整手机号「30 分钟会话级放行」凭证的前端持有（仅内存）。
 *
 * 后端二次密码校验通过后返回 grace 凭证 + 过期时间；本模块在当前页面会话内
 * 持有它，30 分钟内再次查看完整手机号直接携带 grace 免输密码。过期 / 整页刷新
 * 即失效，需重新输入当前管理员登录密码。绝不持久化到 localStorage / cookie。
 */
let graceToken: string | null = null;
let graceExpiresAtMs = 0;

/** 返回仍有效的 grace 凭证；过期 / 未签发返回 null（调用方据此弹出密码框）。 */
export function getValidGraceToken(nowMs: number = Date.now()): string | null {
  if (graceToken && graceExpiresAtMs > nowMs) return graceToken;
  return null;
}

/** 记住后端续签的 grace 凭证（每次成功揭示都会刷新 30 分钟窗口）。 */
export function rememberGrace(token: string, expiresAtIso: string): void {
  const exp = Date.parse(expiresAtIso);
  if (!token || Number.isNaN(exp)) return;
  graceToken = token;
  graceExpiresAtMs = exp;
}

/** 清除 grace（登出 / 凭证被拒时调用）。 */
export function clearGrace(): void {
  graceToken = null;
  graceExpiresAtMs = 0;
}
